import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import yhlogin from '@/components/yhlogin'
import authorization from '@/components/authorization'
import countdown from '@/components/countdown'
import successful from '@/components/successful'
import bidding from '@/components/bidding'
import biddingform from '@/components/biddingform'
import supply from '@/components/supply'
import supplyform from '@/components/supplyform'
import purchasing from '@/components/purchasing'
import purchasingform from '@/components/purchasingform'
import HomeTimer from '@/components/HomeTimer'
import article from '@/components/article'
import articleform from '@/components/articleform'
import article1 from '@/components/article1'
import article1form from '@/components/article1form'
import article2 from '@/components/article2'
import article2form from '@/components/article2form'
import companyshow from '@/view/companyshow'
import addresslist from '@/view/addresslist'
import supplyList from '@/view/supplyList'
import searchsuppplyList from '@/view/searchsuppplyList'
import supplynull from '@/view/supplynull'
import searchpurchasingList from '@/view/searchpurchasingList'
import purchasingnull from '@/view/purchasingnull'
import purchasingList from '@/view/purchasingList'
import articleList from '@/view/articleList'
import searcharticleList from '@/view/searcharticleList'
import articlenull from '@/view/articlenull'
import companyshowList from '@/view/companyshowList'
import searchcompanyshowList from '@/view/searchcompanyshowList'
import companyshownull from '@/view/companyshownull'
import addresslistList from '@/view/addresslistList'
import addresslistnull from '@/view/addresslistnull'
import searchaddresslistList from '@/view/searchaddresslistList'
import screen from '@/view/screen'
import country from '@/view/country'
import countryList from '@/view/countryList'
import searchcountry from '@/view/searchcountry'
import meeting from '@/view/meeting'
import meetingList from '@/view/meetingList'
import searchmeetingList from '@/view/searchmeetingList'
import meetingnull from '@/view/meetingnull'
import areacountry from '@/view/areacountry'
import supplysearch from '@/view/supplysearch'
import purchasingcountry from '@/view/purchasingcountry'
import purchasingsearch from '@/view/purchasingsearch'
import newsList from '@/view/newsList'
import newsDetail from '@/view/newsDetail'


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default new Router({
  // base:'',
  mode: 'history',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
      // meta: {
      //   requireAuth: true
      //   }
    },
    {
      path: '/yhlogin',
      name: 'yhlogin',
      component: yhlogin
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: authorization
      // meta: {
      //      requireAuth: true
      //   }
    },
    {
      path: '/countdown',
      name: 'countdown',
      component: countdown
    },
    {
      path: '/successful',
      name: 'successful',
      component: successful
    },
    //
    {
      path: '/bidding',
      name: 'bidding',
      component: bidding,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
    },
    {
      path: '/biddingform',
      name: 'biddingform',
      component: biddingform,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/supply',
      name: 'supply',
      component: supply,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
      redirect: '/supplyList',
      children: [
        //供应信息列表页
        {
          path: '/supplyList',
          name: 'supplyList',
          component: supplyList
        },//搜索-供应信息列表页
        {
          path: '/searchsuppplyList',
          name: 'searchsuppplyList',
          component: searchsuppplyList
        }
        ,//搜索-供应搜索关键词
        {
          path: '/supplynull',
          name: 'supplynull',
          component: supplynull
        }
      ]
    },
    {
      path: '/supplyform',
      name: 'supplyform',
      component: supplyform,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/purchasing',
      name: 'purchasing',
      component: purchasing,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
      redirect: '/purchasingList',
      children: [
        //求购信息列表页
        {
          path: '/purchasingList',
          name: 'purchasingList',
          component: purchasingList
        },//搜索-求购信息列表页
        {
          path: '/searchpurchasingList',
          name: 'searchpurchasingList',
          component: searchpurchasingList
        }
        ,//搜索-求购搜索关键词
        {
          path: '/purchasingnull',
          name: 'purchasingnull',
          component: purchasingnull
        }
      ]
    },
    {
      path: '/purchasingform',
      name: 'purchasingform',
      component: purchasingform,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/HomeTimer',
      name: 'HomeTimer',
      component: HomeTimer
    },
    {
      path: '/article',
      name: 'article',
      component: article,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
      redirect: '/articleList',
      children: [
        //新闻动态列表页
        {
          path: '/articleList',
          name: 'articleList',
          component: articleList
        },//搜索-新闻动态列表页
        {
          path: '/searcharticleList',
          name: 'searcharticleList',
          component: searcharticleList
        }
        ,//搜索-新闻动态搜索关键词
        {
          path: '/articlenull',
          name: 'articlenull',
          component: articlenull
        }
      ]
    },
    {
      path: '/articleform',
      name: 'articleform',
      component: articleform,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/article1',
      name: 'article1',
      component: article1,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
    },
    {
      path: '/article1form',
      name: 'article1form',
      component: article1form,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/article2',
      name: 'article2',
      component: article2,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
    },
    {
      path: '/article2form',
      name: 'article2form',
      component: article2form,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //企业展示
    {
      path: '/companyshow',
      name: 'companyshow',
      component: companyshow,
      redirect: '/companyshowList',
      children: [
        //企业信息列表页
        {
          path: '/companyshowList',
          name: 'companyshowList',
          component: companyshowList
        },//搜索-企业信息列表页
        {
          path: '/searchcompanyshowList',
          name: 'searchcompanyshowList',
          component: searchcompanyshowList
        }
        ,//搜索-企业搜索关键词
        {
          path: '/companyshownull',
          name: 'companyshownull',
          component: companyshownull
        }
      ]
    },
    //通迅录
    {
      path: '/addresslist',
      name: 'addresslist',
      component: addresslist,
      redirect: '/addresslistList',
      children: [
        //通迅录信息列表页
        {
          path: '/addresslistList',
          name: 'addresslistList',
          component: addresslistList
        },//搜索-通迅录信息列表页
        {
          path: '/searchaddresslistList',
          name: 'searchaddresslistList',
          component: searchaddresslistList
        }
        ,//搜索-通迅录搜索关键词
        {
          path: '/addresslistnull',
          name: 'addresslistnull',
          component: addresslistnull
        }
      ]
    },
    //全国城市
    {
      path: "/country",
      name: "country",
      component: country,
      redirect: '/countryList',
      children: [
        //城市列表页
        {
          path: '/countryList',
          name: 'countryList',
          component: countryList
        },//搜索-城市后显示的供应信息列表
        {
          path: '/searchcountry',
          name: 'searchcountry',
          component: searchcountry
        }
      ]
    },
    //筛选
    {
      path: "/screen",
      name: "screen",
      component: screen
    },
    ,
    {
      path: '/meeting',
      name: 'meeting',
      component: meeting,
      meta: {
        keepAlive: true //需要被缓存的组件
      },
      redirect: '/meetingList',
      children: [
        //会议一览列表页
        {
          path: '/meetingList',
          name: 'meetingList',
          component: meetingList
        },//搜索-会议一览列表页
        {
          path: '/searchmeetingList',
          name: 'searchmeetingList',
          component: searchmeetingList
        }
        ,//搜索-会议一览搜索关键词
        {
          path: '/meetingnull',
          name: 'meetingnull',
          component: meetingnull
        }
      ]
    },
    //城市区域
    {
      path: '/areacountry',
      name: 'areacountry',
      component: areacountry,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //同级供应搜索关键词页
    {
      path: '/supplysearch',
      name: 'supplysearch',
      component: supplysearch,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //求购－城市区域
    {
      path: '/purchasingcountry',
      name: 'purchasingcountry',
      component: purchasingcountry,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //求购信息搜索
    {
      path: '/purchasingsearch',
      name: 'purchasingsearch',
      component: purchasingsearch,
      meta: {
        keepAlive: false // 不需要缓存
      }
    },//文章类-详情页
    {
      path: '/newsDetail',
      name: '/newsDetail',
      component: newsDetail,
    },//文章类-列表页
    {
      path: '/newsList',
      name: '/newsList',
      component: newsList
    }

  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js